'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var difference = require('./difference.js');
function without(array) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        values[_key - 1] = arguments[_key];
    }
    return difference.difference(array, values);
}
exports.without = without;
